import Dropdown, {
  VirtualizedDropdown,
  DropdownProps,
  VirtualizedDropdownProps,
} from 'core/dropdown';

export type DropdownWrapperProps = (VirtualizedDropdownProps | DropdownProps) & {
  useVirtualized?: boolean;
  disabled?: boolean;
};

/**
 * Proxy HOC for enabling/disabling `VirtualizedDropdown`
 * @param props
 * @returns
 */
export const DropdownWrapper = (props: DropdownWrapperProps) => {
  const { useVirtualized = false, selectedIndex, ...rest } = props;
  if (useVirtualized)
    return (
      <VirtualizedDropdown selectedIndex={selectedIndex} {...(rest as VirtualizedDropdownProps)} />
    );

  return <Dropdown {...(rest as DropdownProps)} />;
};
